import { Component, DestroyRef, inject } from '@angular/core';
import { CryptoTokenFormComponent } from '../components/crypto-token-form/crypto-token-form.component';
import { CryptotokenSlotsService } from 'src/app/shared/store/features/cryptotoken-slots/cryptotoken-slots.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { CreateCryptoTokenRequestDto } from 'src/app/shared/services/api/dto/create-crypto-token-request-dto';
import { PageService } from 'src/app/shared/page/service/page.service';
import { Page } from 'src/app/shared/page/page.config';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { SpinnerComponent } from 'src/app/shared/components/spinner/spinner.component';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { catchError, finalize, of, tap } from 'rxjs';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';

@Component({
  selector: 'app-new-cryptotoken-page',
  imports: [CryptoTokenFormComponent, SpinnerComponent],
  templateUrl: './new-cryptotoken-page.component.html',
  styleUrl: './new-cryptotoken-page.component.scss',
})
export class NewCryptotokenPageComponent {
  private cryptotokenSlotsService = inject(CryptotokenSlotsService);
  private pageService = inject(PageService);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private destroyRef = inject(DestroyRef);
  private lang = inject(LangService).lang;
  private labels = this.lang.newCryptotoken;

  isCreating = false;

  // slots = signal<string[] | undefined>(undefined);
  slots = toSignal(this.cryptotokenSlotsService.cryptotokenSlots$);
  // areSlotsLoading = signal(false);
  areSlotsLoading = toSignal(
    this.cryptotokenSlotsService.areCryptotokenSlotsLoading$,
  );

  onNeedSlots() {
    this.cryptotokenSlotsService.ensureCryptotokenSlots();
  }

  private onSuccess() {
    this.toastrService.success(this.labels.toasts.created);
    this.pageService.goToPage(Page.CryptotokenList);
  }

  private onFail(error: unknown) {
    console.error('Crypto token creation error', error);
    this.toastrService.error(
      extractErrorMessage(error) || this.labels.toasts.fail,
    );
  }

  onRequest(dto: CreateCryptoTokenRequestDto) {
    this.isCreating = true;
    this.apiService
      .newCryptotoken(dto)
      .pipe(
        tap(() => {
          this.onSuccess();
        }),
        catchError(error => {
          this.onFail(error);
          return of();
        }),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.isCreating = false;
        }),
      )
      .subscribe();
  }

  onCancel() {
    this.pageService.goToPage(Page.CryptotokenList);
  }
}
